function findLastIndex(array, predicate) {
  let index = array.length - 1;
  while (index >= 0) {
    const element = array[index];
    if (element && predicate(element)) {
      return index;
    }
    index--;
  }
  return -1;
}

export { findLastIndex };
//# sourceMappingURL=find-last-index.js.map
